// منع خلط اللغات في الحقول المحددة للغة: حقل عربي يرفض الأحرف اللاتينية، وحقل إنجليزي يرفض الأحرف العربية.
const ARABIC = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g;
const LATIN = /[A-Za-z]/g;

export const stripLang = (text, lang) => {
  if (!text) return text;
  if (lang === "ar") return text.replace(LATIN, "");
  if (lang === "en") return text.replace(ARABIC, "");
  return text;
};
